//funcion para el buscador que crea keywords
export const createKeyword = text => {
  const listKeywords = [];
  //crea un array que separa las palabras ["palabra1","palabra2"]
  const listWords = text.match(/("[^"]+"|[^"\s]+)/g);
  //divide la frase en palabras y crea un array de palabras
  listWords.forEach(word => {
    let words = "";
    word.split("").forEach(letter => {
      words += letter;
      listKeywords.push(words.toLowerCase());
    });
  });
    //divide las palabras en letras y crea un array de letras
  let letters = "";
  text.split("").forEach(letter => {
    letters += letter;
    listKeywords.push(letters);
  });

  return listKeywords;
};
